import {Controller} from "@hotwired/stimulus"


/**
 *
 * Used by DaisyUI to close all open details elements when
 * clicking outside of them or pressing the Escape key.
 *
 */


export default class extends Controller {

    connect() {
        this.closeAllDetails()
    }


    closeAllDetails() {
        document.addEventListener('click', this.closeAllOpenDetails);
        document.addEventListener('keyup', (event)   => {
            if (event.key === "Escape") {
                this.closeAllOpenDetails()
            }
        })
    }

    closeAllOpenDetails() {
        document.querySelectorAll('details.c-dropdown[open]').forEach((detail) => {
            detail.removeAttribute('open');
        });
    }

}
